export default () => {
  document.getElementById('popContainer').scrollTop = 0
}